import React, { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { FaServer, FaPaintBrush, FaPlay } from "react-icons/fa";

const items = [
  { key: "servers", label: "+100", desc: "serveurs configurés", icon: FaServer },
  { key: "logos", label: "+50", desc: "logos créés", icon: FaPaintBrush },
  { key: "views", label: "+1M", desc: "vues générées TikTok", icon: FaPlay },
];

const Reassurance = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className={`py-12 ${isDark ? "bg-transparent" : "bg-slate-50"}`} aria-labelledby="reassurance-title">
      <div className="max-w-7xl mx-auto px-4">
        <h3 id="reassurance-title" className={`text-center text-lg font-semibold mb-6 ${isDark ? "text-white" : "text-gray-800"}`}>Nos garanties</h3>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.key}
                className={`${isDark ? "bg-[#0f1114] border border-white/6" : "bg-white/95 border border-gray-100"} rounded-xl p-6 flex items-start gap-4 shadow-sm hover:shadow-md transition`}
                role="article"
                aria-label={it.desc}
              >
                <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${isDark ? "bg-rose-600/20" : "bg-rose-50"}`}>
                  <Icon className={`${isDark ? "text-rose-300" : "text-rose-600"} text-2xl`} />
                </div>

                <div className="flex-1">
                  <div className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-800"}`}>{it.label}</div>
                  <div className={`mt-1 text-sm ${isDark ? "text-gray-300" : "text-gray-600"}`}>{it.desc}</div>
                  <div className="mt-3">
                    <div className={`h-1 w-20 rounded-full ${isDark ? "bg-rose-500" : "bg-rose-400"}`} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Reassurance;
